import { render } from "./NcrmOnboardingTemplates.vue?vue&type=template&id=685052e8"
import script from "./NcrmOnboardingTemplates.vue?vue&type=script&lang=js"
export * from "./NcrmOnboardingTemplates.vue?vue&type=script&lang=js"

import "./NcrmOnboardingTemplates.styles.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__